import { render, staticRenderFns } from "./ClientsInactive.vue?vue&type=template&id=4d3b14e0&scoped=true"
import script from "./ClientsInactive.vue?vue&type=script&lang=js"
export * from "./ClientsInactive.vue?vue&type=script&lang=js"
import style0 from "./ClientsInactive.vue?vue&type=style&index=0&id=4d3b14e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b14e0",
  null
  
)

export default component.exports